import React from 'react';
import ReactQueryProvider from './ReactQueryProvider';
import {SessionProvider} from './SessionProvider';

export const ProvidersAndHooks = ({
                                      children,
                                  }: {
    children: JSX.Element;
}): JSX.Element => {
    return (
        <ReactQueryProvider>
            <SessionProvider>
                {children}
            </SessionProvider>
        </ReactQueryProvider>
    );
};

export default ProvidersAndHooks;
